import React from "react"
import {connect} from 'react-redux'
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

// core components
import GridContainer from "components/GridContainer"
import GridItem from "components/GridItem"

import extendedTablesStyle from "./extendedTablesStyle.jsx"

import {mapService} from "../../_services";

import 'leaflet/dist/leaflet.css';
import L from "leaflet";
import "../../components/LeafletIndoor/leaflet-indoor";
import {Map, Marker, Popup} from 'react-leaflet'
import {Alert} from "@mui/material";

function get_length_width(feature) {
  let min_x = null
  let max_x = null
  let min_y = null
  let max_y = null

  feature.geometry.coordinates[0].forEach((coordinate) => {
    let x = coordinate[0]
    let y = coordinate[1]

    if (min_x === null || x < min_x) {
      min_x = x
    }
    if (max_x === null || x > max_x) {
      max_x = x
    }
    if (min_y === null || y < min_y) {
      min_y = y
    }
    if (max_y === null || y > max_y) {
      max_y = y
    }
  })

  let length = Math.round((Math.max(max_y - min_y, max_x - min_x) + Number.EPSILON) * 100) / 100
  let width = Math.round((Math.min(max_y - min_y, max_x - min_x) + Number.EPSILON) * 100) / 100
  return {
    length: length, width: width
  }
}


function general_popup_function(feature) {
  if (feature.properties.node_type === "gutter") {
    return "Gutter: " + feature.properties.gutter_number
  }
  if (feature.properties.node_type === "obstacle") {
    return "Obstacle: " + feature.properties.obstacle_type
  }
  if (feature.properties.node_type === "lane") {
    let size = get_length_width(feature)
    return `Lane: ${feature.properties.node_id} | Size: ${size['length']}m x ${size['width']}m`
  }
  if (feature.properties.node_type === "walkway") {
    let size = get_length_width(feature)
    return `Walkway: ${feature.properties.node_id} | Size: ${size['length']}m x ${size['width']}m`
  }
  return "ID: " + feature.properties.node_id
}


class GreenhouseMap extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      map_id: undefined,
      map_version: undefined,
      gutter_layer_version: undefined,
      obstacle_layer_version: undefined,
      map: {},
      allow_alternate: false,
    }

    this.timer = null
    this._is_mounted = false
  }

  componentDidMount() {
    this._is_mounted = true
    this.refresh()
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
    this._is_mounted = false
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      map_id,
      map_version,
      gutter_layer_version,
      obstacle_layer_version,
      crop_state,
      force_refresh
    } = this.props
    if (
      prevProps.map_id !== map_id ||
      prevProps.map_version !== map_version ||
      prevProps.gutter_layer_version !== gutter_layer_version ||
      prevProps.obstacle_layer_version !== obstacle_layer_version ||
      prevProps.crop_state !== crop_state ||
      prevProps.force_refresh !== force_refresh
    ) {
      this.refresh()
    }
  }

  refresh() {
    const {map_id, map_version, gutter_layer_version, obstacle_layer_version} = this.props
    let gutter_version = undefined
    let obstacle_version = undefined
    if (map_id === undefined || map_id === null || map_version === undefined || map_version === null) {
      return
    }
    this.setState({allow_alternate: false})

    let split_map_version = map_version.split("#")[0]
    let [major, minor, patch] = split_map_version.split(".")
    if (split_map_version.includes("-1")) {
      split_map_version = major + "." + minor + ".1"
    }

    if (gutter_layer_version !== undefined) {
      if (gutter_layer_version.startsWith(split_map_version)) {
        gutter_version = gutter_layer_version
      } else {
        gutter_version = split_map_version + "." + gutter_layer_version
      }
    }

    if (obstacle_layer_version !== undefined) {
      if (obstacle_layer_version.startsWith(split_map_version)) {
        obstacle_version = obstacle_layer_version
      } else {
        obstacle_version = split_map_version + "." + obstacle_layer_version
      }
    }

    mapService.exportGeoJson(map_id, split_map_version, gutter_version, obstacle_version, res => {
      this.setState({map: res.result}, () => {
        this.createIndoorLayers()
        this.createCropState()
      })
    })
  }

  createIndoorLayers() {
    const {map_id, popup_function} = this.props;
    const {map, current_layer} = this.state;

    if (this.refs.mymapforheatmap === undefined) {
      return
    }
    let map_reference = this.refs.mymapforheatmap.leafletElement;
    map_reference.attributionControl = false
    if (current_layer !== undefined)
      map_reference.removeLayer(current_layer)

    if (map === undefined || Object.keys(map).length === 0 || map === null) {
      this.setState({allow_alternate: true})
      return
    }

    let indoorLayer = new L.Indoor(map, {
      getLevel: function (feature) {
        return 0;
      },
      onEachFeature: function (feature, layer) {
        layer.bindPopup(popup_function === undefined ? general_popup_function(feature) : popup_function(feature));
      }, style: this.style_function.bind(this)
    });

    indoorLayer.addTo(map_reference);
    indoorLayer.id = map_id;
    indoorLayer.setLevel(0)

    this.setState({current_layer: indoorLayer, allow_alternate: false})
  }

  createCropState() {
    const {popup_function, crop_state} = this.props;
    const {crop_state_layer} = this.state;

    if (this.refs.mymapforheatmap === undefined) {
      return
    }
    let map_reference = this.refs.mymapforheatmap.leafletElement;
    map_reference.attributionControl = false
    if (crop_state_layer !== undefined)
      map_reference.removeLayer(crop_state_layer)

    if (crop_state === undefined || Object.keys(crop_state).length === 0 || crop_state === null) {
      return
    }

    let indoorLayer = new L.Indoor(crop_state, {
      getLevel: function (feature) {
        return 2;
      },
      onEachFeature: function (feature, layer) {
        layer.bindPopup(popup_function === undefined ? general_popup_function(feature) : popup_function(feature));
      }, style: this.get_crop_state_style.bind(this)
    });

    indoorLayer.addTo(map_reference);
    indoorLayer.id = "crop_state";
    indoorLayer.setLevel(2)

    this.setState({crop_state_layer: indoorLayer})
  }

  get_crop_state_style(feature) {
    return {
      fillColor: feature.properties.fillColor, fill: true, weight: 1, color: feature.properties.fillColor, fillOpacity: 0.5
    }
  }

  style_function(feature) {
    const {style_function} = this.props
    if (style_function !== undefined) {
      return style_function(feature)
    }

    let color = 'white';
    let fillOpacity = 0.5;
    let weight = 1;
    if (feature.properties.node_type === 'walkway') {
      color = '#0A485B';
      fillOpacity = 0.01;
    } else if (feature.properties.node_type === 'lane') {
      color = '#666';
      fillOpacity = 0.2;
      weight = 0.2;
    } else if (feature.properties.node_type === 'gutter') {
      color = '#638813';
      fillOpacity = 0.5;
    } else if (feature.properties.node_type === 'obstacle') {
      color = '#881317';
      fillOpacity = 0.5;
    }
    return {
      fillColor: color, fill: true, weight: weight, color: "#666", fillOpacity: fillOpacity
    };
  }

  get_markers() {
    const {markers} = this.props
    let parsed_markers = []

    markers.forEach((marker) => {
      parsed_markers.push({
        "position": [marker["y"], marker["x"]],
        "key": marker["key"],
        "icon": marker["icon"],
        "popup": marker["popup"]
      })
    })

    return parsed_markers
  }

  render() {
    const {map, allow_alternate} = this.state
    const {map_version, map_id, alternate} = this.props
    let split_map_version = ""

    if (map_version) {
      split_map_version = map_version.split("#")[0]
      let [major, minor, patch] = split_map_version.split(".")
      if (split_map_version.includes("-1")) {
        split_map_version = major + "." + minor + ".1"
      }
    }
    if (map === undefined || Object.keys(map).length === 0 || map === null) {
      if (allow_alternate) {
        return alternate
      }
    }

    let markers = this.get_markers()

    return (
      <GridContainer>
        <GridItem xs={12}>
          {map_version && map_version.includes("-1") &&
            <Alert variant={"outlined"} severity={"error"}>
              Found an illegal map version, defaulting to {split_map_version}
            </Alert>
          }
          <Map
            center={[0, 0]}
            zoom={5}
            maxZoom={7}
            minZoom={2}
            style={{width: '100%', height: '900px'}}
            ref='mymapforheatmap'
            crs={L.CRS.Simple}
          >
            {
              markers.map((marker) => {
                return <Marker
                  key={`marker-${marker["key"]}`}
                  icon={marker["icon"]}
                  position={marker["position"]}
                  draggable={false}
                  attribution={"CalibratedMarker"}
                >
                  <Popup>
                    {marker["popup"]}
                  </Popup>
                </Marker>
              })
            }
          </Map>
          Map: {map_id} - {map_version}
        </GridItem>
      </GridContainer>
    )
  }
}


function mapStateToProps(state) {
  return {}
}


GreenhouseMap.defaultProps = {
  alternate: "Map could not be generated",
  markers: [],
}

export default withStyles(extendedTablesStyle)(connect(mapStateToProps)(GreenhouseMap))
